import { Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { emailValidator,  EmailMatchValidation, checkExpiryDate, checkCSVCode, numberValidator } from 'src/app/theme/utils/app-validators';
import { FormBuilder, FormGroup, Validators, ValidatorFn, ValidationErrors, FormControl } from '@angular/forms';
import { MatProgressButtonOptions } from 'mat-progress-buttons';
import { ApiService } from 'src/app/shared/services/api.service';
import { MatDialog } from '@angular/material/dialog';
import { MouseEvent } from '@agm/core';
import { CreditCardValidators as ccValidator, CreditCard } from 'angular-cc-library';
import { storeLinksType } from 'src/app/types/sign-in';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { displayErrorMessage, removeWhiteSpaces } from 'src/app/theme/utils/util-functions';
import { Observable, Subject, Subscription } from 'rxjs';
import { Router, NavigationEnd, Event, ActivatedRoute } from '@angular/router';
import { MatHorizontalStepper } from '@angular/material/stepper';
import { PopupComponent } from 'src/app/theme/components/popup/popup.component';
import { HttpErrorResponse } from '@angular/common/http';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { MatTabGroup } from '@angular/material/tabs';
import { DOCUMENT } from '@angular/common';
import { FeatureTagObject } from 'src/app/types/feature-tags';
import { StripeService, StripeCardNumberComponent,STRIPE_PUBLISHABLE_KEY  } from 'ngx-stripe';
import { SharedDataService } from 'src/app/shared/services/sharedata.service';
import {
  StripeCardElementOptions,
  StripeElementsOptions,
  StripeCardExpiryElementOptions,
  StripeCardNumberElementOptions,
  PaymentIntent,
  StripeCardElementChangeEvent,
} from '@stripe/stripe-js';
import { SafeHtml } from '@angular/platform-browser';


interface CustomValidationErrors extends ValidationErrors {
  atLeastOneOptionSelected?: boolean;
}

export const checkDeliveryOptionVaild: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const pickupLocation = control.get('pickupLocation').value;
  const delivery_address = control.get('delivery_address').value;

  return pickupLocation || delivery_address ? null : { atLeastOneOptionSelected: true };
};
@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})

export class RegistrationComponent implements OnInit {
  @ViewChild('SearchAddressField') SearchAddressField: ElementRef;
  @ViewChild('stepper') stepper: MatHorizontalStepper;
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;

  registerForm: FormGroup;
  stripecreditCardForm: FormGroup;
  showTab1: boolean = true;
  showTab2: boolean = true;
  showTab3: boolean = true;
  creditCardForm: FormGroup;
  Information: FormGroup;
  isEditable = false;
  hide = false;
  isOptional = true;
  isDeliverySetting = true;
  isRegisterSetting = true;
  isFinishDelivery = true;
  isAutocompleteList = false;
  isBtnDisabled: boolean = true;
  storeDetails = [];
  routeTempletes = [];
  showAutocompleteAddressLoading: boolean = false;
  autocompleteAddressList: Array<object> = [];
  selectedListItem = null;
  selectedAutocompleteAddress = null;
  selectedAddress = null;
  showDeliveryAddress: boolean = true;
  showPickupInfo: boolean = false;
  showPickupAddress:boolean = false;
  displayNotDeliverable:boolean = false;
  deliveryStatusPopup = [];
  pickupLocationId = null;
  pickupLocations = [];
  pickupLocError: boolean = false;
  selPickupLocation = [];
  addressDetails = [];
  storeLinksJson: storeLinksType[] = [];
  termsOfUse: string;
  privacyPolicy: string;
  address_id = null;
  isLoadingSignUpBtn: boolean = false;
  isLoadingSignInBtn: boolean = false;
  cardInformationStatus:boolean = false;
  addressDetailsStatus:boolean = false;
  storedetails1 = {};
  subscripeNavigation: Subscription;
  registerData: Array<object> = [];
  public lat: number;
  public lng: number;
  public zoom: number = 9;
  deliveryOptions = [];
  knownBy = [
    { label: 'Google', value: 'Google' },
    { label: 'Word of Mouth', value: 'Word of Mouth' },
    { label: 'Mail (Postcard)', value: 'Mail (Postcard)' },
    { label: 'Flyer', value: 'Flyer' },
    { label: 'TV Commercial', value: 'TV Commercial' },
    { label: 'Facebook', value: 'Facebook' },
    { label: 'News', value: 'News' },
    { label: 'Seen Milk Truck', value: 'Seen Milk Truck' },
    { label: 'Ad Sign', value: 'Ad Sign' }
  ];
  countries = [];
  options = ['Delivery','Pickup']
  saveButtonDisabled = true;
  displayDeliveryAddress = false;
  markers:marker[];

  locationControl = new FormControl();
  locations: any[] = [];
  filteredDeliveryLocation: Observable<string[]>;
  searchLocationKeys  = new Subject<string>();
  featureTags: FeatureTagObject = <FeatureTagObject>{};
  showReferralInput = false;
  paymentDetailsJson:any;
  paymentCashOnDelivery:any;
  stripeKey: string | null = null;
  paymentMethod: string | null = null;
  @ViewChild(StripeCardNumberComponent) card: StripeCardNumberComponent;

  cardOptions: StripeCardElementOptions = {
    style: {
      base: {
        iconColor: '#666EE8',
        color: '#31325F',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSize: '14px',
        '::placeholder': {
          color: '#CFD7E0',
        },
      },
    },
  };
  cardNumberOption :StripeCardNumberElementOptions = {
    ...this.cardOptions,
    placeholder: 'Card number',
  }
  expiryOption: StripeCardExpiryElementOptions = {
    ...this.cardOptions,
    placeholder: 'MM / YY',
  };

  elementsOptions: StripeElementsOptions = {
    locale: 'en',
  };
  carderrorMessage: string | null = null;
  expiryerrorMessage: string | null = null;
  cvcerrorMessage: string | null = null;
  stripeFormValid:boolean = false;
  showPickupEvents:boolean = false;
  pickupEvents = [];
  pickupEventControl = new FormControl('', Validators.required);
  selectedPaymentMethod: string = 'Credit Card';
  safeHtmlContent: SafeHtml;
  isTermandConditionRequired: boolean = false;
  


  constructor(
    public formBuilder: FormBuilder, 
    public snackBar: MatSnackBar,
    public apiService: ApiService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public router: Router,
    private sharedDataService: SharedDataService,
    private notification: NotificationService,
    @Inject(DOCUMENT) private document: Document,
    private stripeService: StripeService
  ) { 
    this.registerForm = this.formBuilder.group(
      {
      first_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.maxLength(35),
        ]),
      ],
      last_name: [
        "",
        Validators.compose([
          Validators.required,
          Validators.maxLength(35),
        ]),
      ],
      email_id: [
        "",
        Validators.compose([Validators.required, emailValidator]),
      ],
      verify_email_id: [
        "",
        Validators.compose([Validators.required, emailValidator]),
      ],
      password: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(6),
          Validators.maxLength(20),
        ]),
      ],
      phone_number: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(10),
          numberValidator
        ]),
      ],
      company:'',
      known_by: ['', Validators.compose([Validators.required])],
      internal_notes: ["",],
      newsletter_subscription: ["true"],
      terms_and_conditions: [false]
      },
      {
        validator: EmailMatchValidation.MatchPassword,
      }
    );
    this.creditCardForm = this.formBuilder.group({
        number: ['', [Validators.required, ccValidator.validateCCNumber]],
        expiry: ['', [Validators.required, checkExpiryDate]],
        cvc: ['', [Validators.required, numberValidator]],
        address: ['', [Validators.required, Validators.maxLength(60)]],
        city: ['', [Validators.required]],
        state: ['', [Validators.required]],
        zipcode: ['', [Validators.required, Validators.minLength(5),Validators.maxLength(9), Validators.pattern('^[0-9]*$')]]
      },{validator: checkCSVCode('cvc', 'number')});

    this.stripecreditCardForm = this.formBuilder.group({
      address: ['', [Validators.required, Validators.maxLength(60)]],
      city: ['', [Validators.required]],
      state: ['', [Validators.required]],
      zipcode: ['', [Validators.required, Validators.minLength(5),Validators.maxLength(9), Validators.pattern('^[0-9]*$')]]
    });
  }
  saveButtonOptions: MatProgressButtonOptions = {
    active: false,
    text: 'Save Address',
    buttonColor: 'primary',
    spinnerSize: 18,
    raised: true,
    stroked: false,
    fullWidth: false,
    disabled: false,
    mode: 'indeterminate',
  }
  
  ngOnInit() {
    this.storeDetails = JSON.parse(sessionStorage.getItem('store'));
    this.featureTags = JSON.parse(sessionStorage.getItem("featureTags"));

    if (this.storeDetails['fulfillment_options'].includes('Delivery')) 
    {
      this.deliveryOptions.push({ label: 'Delivery', value: 'Delivery' });
    }
    if (this.storeDetails['fulfillment_options'].includes('Pickup')) 
    {
      this.deliveryOptions.push({ label: 'Pickup', value: 'Pickup' });
    }
    if (this.storeDetails['cc_collection_point'] !== "At Registration")
    {
      this.isFinishDelivery = false;
      this.showTab3 = false;
    }
    if (this.storeDetails['delivery_address_input_preference'] !== "Enter at Start")
    {
      this.isDeliverySetting = false;
      this.showTab1 = false;
      this.isBtnDisabled = false;
    }
    this.countries = [{name: 'India', code: 'IN'},{name: 'Panama', code: 'PA'}];
    if(!!this.featureTags && this.featureTags['sf_stripe_payment']){
      this.paymentDetailsJson = this.route.snapshot['data']['store']['response']['data']['payment_method_details'];
    }
    if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
      this.paymentCashOnDelivery = this.route.snapshot['data']['store']['response']['data']['payment_method_details'][0];
    }
      
    if(this.isDeliverySetting){
        this.Information = this.formBuilder.group({
          deliveryOption: [this.deliveryOptions[0].value, Validators.required],
          delivery_address:['', [Validators.required]],
          pickupLocation:['All'],
          apt_suite_no: [{ value: '', disabled: true }, [Validators.maxLength(50)]],
          address: [{ value: '', disabled: true }, [Validators.required, Validators.maxLength(60)]],
          city: [{ value: '', disabled: true }, [Validators.required]],
          state: [{ value: '', disabled: true }, [Validators.required]],
          zipcode: [{ value: '', disabled: true }, [Validators.required, Validators.minLength(5),Validators.maxLength(10)],false],
          address_2 : ['']
        }//,{validators: checkDeliveryOptionVaild}
        );
    }
    
    this.filteredDeliveryLocation = this.locationControl.valueChanges
    .pipe(
      startWith(''),
      map(value => this._locationfilter(value))
    );
    this.searchLocationKeys
    .pipe(debounceTime(500),
        distinctUntilChanged()
    ).subscribe((e) => { 
      this.searchDeliveryLocation(e);
    });
    this.getLinks();

    if(this.storeDetails['fulfillment_options'].includes('Delivery')){
      this.showDeliveryAddress = true;
      this.showPickupInfo = false;
      this.changePreference();
    }else{
      this.showDeliveryAddress = false;
      this.showPickupInfo = true;
      this.changePreference();
    }

    if(!!this.featureTags && this.featureTags['sf_stripe_payment']){
      let test =false
      // if(test){
        this.stripeKey = this.getStripePublishableKey();
        this.paymentMethod = this.getPaymentMethod();  
        if (this.stripeKey) {
          this.stripeService.setKey(this.stripeKey); // Set the key dynamically
        }
      // }
    }
    if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
          this.storedetails1 = this.route.snapshot.data['store']['response']['data']['store'];
    }
    if(!!this.featureTags && this.featureTags['sf_enhance_registration'] && this.storedetails1['enable_website_terms_condition']){
      this.registerForm.get('terms_and_conditions')?.setValidators(Validators.requiredTrue);
      this.registerForm.get('terms_and_conditions')?.updateValueAndValidity();
      this.GetCMSPages();
    }
    this.knownBy = this.route.snapshot.data?.['store']?.['response']?.['data']?.['store_json']?.['registration_options'] || this.knownBy;
  }
  getPaymentMethod(): string | null {
    const _name = this.paymentDetailsJson.find(
      item => item.description === "Credit Card"
    );
    return _name ? _name.name : null;
  }
    
  getStripePublishableKey(): string | null {
    const _key = this.paymentDetailsJson.find(
      item => item.description === "Credit Card" && item.name === "stripe"
    );
    return _key ? _key.stripe_publishable_key : null;
  }
  setFocusSF() {
    setTimeout(() => {
      this.SearchAddressField.nativeElement.focus();
    }, 10);
  }
  searchFieldCustomers(e) {
    this.searchLocationKeys.next(e);
  }
  validateNumber(event: KeyboardEvent, maxLength = 0) {
    const key = event.key;
   
    const inputElement = event.target as HTMLInputElement;
    if(maxLength>0){
      if (inputElement.value.length >= 10) {
        event.preventDefault(); // Stop input if the length exceeds 10
      }
    }
    
    if (!/^[0-9]$/.test(key)) {
      event.preventDefault();
    }
  }

  validatePaste(event: ClipboardEvent) {
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedData = clipboardData.getData('Text');
    if (!/^[0-9]*$/.test(pastedData)) {
      event.preventDefault();
    }
  }
  private _locationfilter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.locations.filter(l => l.toLowerCase().includes(filterValue));
  }
  onKnownByChange(selectedValue: string) {
    if(this.featureTags && this.featureTags['sf_word_of_mouth']){
      if (selectedValue === 'Word of Mouth' || selectedValue === 'Personal Referral') {
        this.showReferralInput = true;
        this.registerForm.get('internal_notes')?.enable(); // Enable the input field
      } else {
        this.showReferralInput = false;
        this.registerForm.get('internal_notes')?.disable(); // Disable the input field
        this.registerForm.get('internal_notes')?.reset(); // Clear the input field
      }      
    }
  }
  searchDeliveryLocation(e) { 
    this.autocompleteAddressList = [];
    this.saveButtonDisabled = true;
    let params = e.target.value;
    if(params.length > 0) {
      this.apiService.getPlacesAutocomplete(params).subscribe(result => {
        let res = result['response'];
        if(res['status'] === 0) {
          let message = !!res['message'] ? res['message'] : 'Something went wrong!';
        }else if(res['status'] === 1) {
          // this.isAutocompleteList = true;
          this.autocompleteAddressList = res['addresses'];
          
        }
        this.showAutocompleteAddressLoading = false;
        this.displayDeliveryAddress = false;
      });
    }
  }

  private _filter(value: any): any {
    throw new Error('Method not implemented.');
  }
  checkTabs(){
    if(this.pickupLocations || this.selectedAddress !== null){
      this.isBtnDisabled = false; 
    }
  }
  onExpirationInput(event: any) {
    let input = event.target.value.replace(/\D/g, '');
    let formattedInput = '';

    // Format expiration date as MM/YY
    if (input.length > 2) {
      formattedInput += input.substr(0, 2) + '/' + input.substr(2);
    } else {
      formattedInput += input;
    }
    this.creditCardForm.controls['expiry'].setValue(formattedInput);
  }
  changeCreditCardnumber(event: any) {
    let input = event.target.value.replace(/\D/g, '');
    let formattedInput = '';

    // Format credit card number with space every four digits
    for (let i = 0; i < input.length; i++) {
      if (i % 4 === 0 && i > 0) {
        formattedInput += ' ';
      }
      formattedInput += input.charAt(i);
    }

    this.creditCardForm.controls['number'].setValue(formattedInput);
    if(this.creditCardForm.controls['number'].valid) {
      this.creditCardForm.controls['cvc'].enable();
    }else {
      this.creditCardForm.controls['cvc'].setValue('');
      this.creditCardForm.controls['cvc'].disable();
    }
  }
  selectTab(index: number) {
    this.creditCardForm.controls['address'].setValue(this.Information.value.address);
    this.creditCardForm.controls['zipcode'].setValue(this.Information.value.zipcode);
    this.tabGroup.selectedIndex = index;
  }
  getLinks() {
    try {
        let storeLinks: storeLinksType[] = JSON.parse(
            sessionStorage.getItem("storeLinks")
        );
        storeLinks.filter((link) => {
            if (link.label === "terms_of_use") {
                this.termsOfUse = `${this.document.location.origin}/terms-and-conditions`;
            }

            if (link.label === "privacy_policy") {
                this.privacyPolicy = `${this.document.location.origin}/privacy-policy`;
            }
        });
    } catch (error) {
        console.log(error.message);
    }
  }
  
  onDeliveryOptionChange(event: any) {
    this.showPickupAddress = false;
    const selectedValue = event.value;
    this.showDeliveryAddress = selectedValue === 'Delivery';
    this.showPickupInfo = selectedValue === 'Pickup';
    if (selectedValue === 'Delivery') {
      this.Information.get('delivery_address').setValidators(Validators.required);
      this.Information.get('pickupLocation').clearValidators();
      this.setFocusSF();
      this.showPickupInfo = false;
      if(!!this.featureTags && this.featureTags['sf_select_pickup_event']){
        this.pickupEventControl.setValue('');
        this.pickupEventControl.clearValidators();

      }
    } else {
      this.showDeliveryAddress = false;
      this.Information.get('pickupLocation').setValidators(Validators.required);
      this.Information.get('delivery_address').clearValidators();
    }
    this.Information.get('delivery_address').updateValueAndValidity();
    this.Information.get('pickupLocation').updateValueAndValidity();
    
    this.changePreference();
  }
  
  private changePreference() {
    if(this.showPickupInfo){
      this.selectedAddress = [];
      this.apiService.getPickupLocation().subscribe(result => {        
        if(result['response']['status'] === 1){
          this.pickupLocations = result['response']['data']['PickupLocations'];
          this.Information.controls['pickupLocation'].setValue("All");
          this.Information.controls['delivery_address'].setValue("");
          this.selectedAddress = [];
          this.isBtnDisabled = true;
          this.displayDeliveryAddress = false;
          if(this.pickupLocations == null){
            this.notification.error("Please contact the site administrator", 5000);
            this.pickupLocError = true;
            return;
          }else{
            this.pickupLocError = false;
          }          
          const PickupLoc = [];
          this.pickupLocations.map((x,y) => {
            if(y == 0){
              this.lat = x.address.latitude;
              this.lng = x.address.longitude;
            }
            PickupLoc.push({
              lat: x.address.latitude,
              lng: x.address.longitude,
              label: x.name,
              formatAddress: x.address?.address_name+', '+x.address?.city+', '+x.address?.state+', '+x.address?.zipcode,
              deliveryDays: x?.delivery_days.join(', '),
              notes:x?.location_notes
            });
          });
          this.markers = PickupLoc;
        }
      });
    }else{
      this.pickupLocations = [];
      this.Information.controls['pickupLocation'].setValue("");
      this.showPickupAddress = false;
      this.isBtnDisabled = true;
    }
  }

  onPickupEventChange(event: any) {
    console.log(event);
    
  }
  onPickupLocationChange(data:any){
    this.Information.clearValidators();
    this.Information.updateValueAndValidity();
    if(data['value']==='All')
    {
      this.zoom = 9;
      if(!!this.featureTags && this.featureTags['sf_select_pickup_event']){
        this.showPickupEvents = false;
        this.pickupEventControl.setValue('');
      }
    }
    else{
      if(!!this.featureTags && this.featureTags['sf_select_pickup_event']){
        this.apiService.pickupEvent(data['value']['id']).subscribe(result => {          
          if (result['response']['status'] === 1) {
            this.pickupEvents = result['response']['data'];
            this.pickupEventControl.setValue(result['response']['data'][0]);
            this.showPickupEvents = true;
          }else{
            this.pickupEventControl.setValue('');
            this.pickupEventControl.setErrors({ required: true });
            this.pickupEventControl.markAsTouched();
            this.showPickupEvents = false;
        }
      });
    }
      this.zoom = 12;
      this.addressDetails = data['value']['address'];
      this.pickupLocationId = data['value']['id'];
      this.selPickupLocation = data['value'];
      this.showPickupAddress = true;
      this.isBtnDisabled = false;
      this.lat = data['value']['address']['latitude'];
      this.lng = data['value']['address']['longitude']; 
    }
  }
  
  onDeliveryLocation(data:any){
    this.saveButtonDisabled = true;
    let params = data['target'].value;
    if(params.length > 0) {
      this.apiService.getPlacesAutocomplete(params).subscribe(result => {
        let res = result['response'];
        if(res['status'] === 0) {
          let message = !!res['message'] ? res['message'] : 'Something went wrong!';
        }else if(res['status'] === 1) {
          this.isAutocompleteList = true;
          this.autocompleteAddressList = res['addresses'];
        }
        this.showAutocompleteAddressLoading = false;
        this.displayDeliveryAddress = false;
      });
    }
  }
  
  selectedAddressFromList(address: object, index: number) {
    this.selectedListItem = index;
    this.selectedAutocompleteAddress = address;
    this.isBtnDisabled = false;
    this.isAutocompleteList = false;
    this.getAddressFromReverseGeocode();
    this.autocompleteAddressList = [];
  }
  
  getAddressFromReverseGeocode() {
    if(!!this.selectedAutocompleteAddress) {
      let params = this.selectedAutocompleteAddress['place_id'];
      this.apiService.getReverseGeocode(params).subscribe(result => {
        let res = result['response'];
        this.saveButtonDisabled = true;
        if(res['status'] === 0) {
          let message = !!res['message'] ? res['message'] : 'Something went wrong!';
        }else if(res['status'] === 1) {
          this.selectedAddress = res['address'];
          if (res['address']['address'] === ' ' || !res['address']['city'] || !res['address']['state'] || !res['address']['zipcode'])
          {
            this.notification.warning("Invaild Address",5000);
            this.isBtnDisabled = true;
            return false;
          }
          this.Information.controls['address'].setValue(res['address']['address']);
          this.Information.controls['city'].setValue(res['address']['city']);
          this.Information.controls['state'].setValue(res['address']['state']);
          this.Information.controls['zipcode'].setValue(res['address']['zipcode']);
          if (this.selectedAddress !== null)
          {
            let location = this.selectedAddress['geometry'].split(",")
            let geometry = {
              store_id  : this.storeDetails["id"],
              latitude  : location[0],
              longitude : location[1]
            };
            if (this.storeDetails['automatic_route_assignment']) 
            {
              this.apiService.deliveryCheck(geometry).subscribe(result => {                
                if (result['status'] === 1 && (result['data']['deliveryAreas'][0]['route_templates']).length > 0 )
                {
                  this.deliveryStatusPopup["title"] = "Great News: We Can Deliver to You!";
                  this.deliveryStatusPopup["display"] = "To Continue with your purchase, please sign in or register for an account. Don't worry, it only takes a minute, and you'll be brought right back to your cart afterward.";
                  this.deliveryStatusPopup["proceed"] = "Proceed";
                  this.deliveryStatusPopup["showProceedBtn"] = true;
                  this.deliveryStatusPopup["close"] = "Close";
                  this.deliveryStatusPopup["showCloseBtn"] = false;
                  this.deliveryStatusPopup['msg'] = "delivery address alert";
                  this.routeTempletes = result['data']['deliveryAreas'][0]['route_templates'];
                } 
                else if (result['status'] === 2){
                  if (this.storeDetails['waitlist_for_non_service_areas'])
                  {
                    this.deliveryStatusPopup["proceed"] = "Try another Address";
                    this.deliveryStatusPopup["showProceedBtn"] = true;
                    this.deliveryStatusPopup["close"] = "Go Back";
                    this.deliveryStatusPopup["showCloseBtn"] = true;
                    this.deliveryStatusPopup['msg'] = "waiting list form";
                    this.deliveryStatusPopup['address'] = this.selectedAddress;
                  }
                  else
                  {
                    this.deliveryStatusPopup["title"] = "Thank you for your interest!";
                    this.deliveryStatusPopup["display"] = "Unfortunately, we're not yet delivering to your area. However, we're always looking to expand our routes. Please consider joining our waiting list by emailing us. The more interest we reveive form your neighborhood, the sooner we can start delivering to you.";
                    this.deliveryStatusPopup["proceed"] = "Try another Address";
                    this.deliveryStatusPopup["showProceedBtn"] = true;
                    this.deliveryStatusPopup["close"] = "Go Back";
                    this.deliveryStatusPopup["showCloseBtn"] = true;
                    this.deliveryStatusPopup['msg'] = "delivery address alert";
                  }
                }
                else
                {
                  this.deliveryStatusPopup["title"] = "Thank you for your interest!";
                  this.deliveryStatusPopup["display"] = "Unfortunately, we're not yet delivering to your area. However, we're always looking to expand our routes. Please consider joining our waiting list by emailing us. The more interest we reveive form your neighborhood, the sooner we can start delivering to you.";
                  this.deliveryStatusPopup["proceed"] = "Try another Address";
                  this.deliveryStatusPopup["showProceedBtn"] = true;
                  this.deliveryStatusPopup["close"] = "Go Back";
                  this.deliveryStatusPopup["showCloseBtn"] = true;
                  this.deliveryStatusPopup['msg'] = "delivery address alert";
                }
              
              this.locationControl.setValue('');
              const dialogRef = this.dialog.open(PopupComponent , {
                width: '600px',
                data: this.deliveryStatusPopup
              });
              dialogRef.afterClosed().subscribe(result => {
                if (result === "Proceed")
                {
                  this.isBtnDisabled = false;
                  this.Information.get('address').enable();
                 
                  this.Information.get('apt_suite_no')?.enable();
                  this.Information.get('zipcode')?.enable();
                  
                  // this.selectTab(1);
                this.SearchAddressField.nativeElement.blur();

                }
                else if (result === "close" || result === "Try another Address")
                {
                  this.isBtnDisabled = true;
                  this.selectedAddress = [];  
                }
                else
                {
                  this.isBtnDisabled = true;
                  this.selectedAddress = [];  

                }
              });
            },
            (error: HttpErrorResponse) => {
                console.error('An error occurred:', error.error.message);
            });
            }
            else
            {
              let zipcodeCheck = {
                website_check: "global",
                zipcode: res['address']['zipcode']
              };
              this.apiService.checkZipcode(zipcodeCheck).subscribe(zipcodeRes =>{
                if (zipcodeRes['response']['status'] !== 4)
                {
                  this.selectedAddress = [];
                  this.isBtnDisabled = true;
                  this.notification.warning(
                    zipcodeRes["response"].message,
                    5000
                  );
                }
              })
            }            
          } else {
            let message = 'Something went wrong!';
          }
          
          if(!!this.featureTags && this.featureTags['sf_stripe_payment']){
            if(this.paymentMethod ==='authorize_net'){
              this.creditCardForm.controls['address'].setValue(res['address']['address']);
              this.creditCardForm.controls['city'].setValue(res['address']['city']);
              this.creditCardForm.controls['state'].setValue(res['address']['state']);
              this.creditCardForm.controls['zipcode'].setValue(res['address']['zipcode']);
            }else if(this.paymentMethod ==='stripe'){
              this.stripecreditCardForm.controls['address'].setValue(res['address']['address']);
              this.stripecreditCardForm.controls['city'].setValue(res['address']['city']);
              this.stripecreditCardForm.controls['state'].setValue(res['address']['state']);
              this.stripecreditCardForm.controls['zipcode'].setValue(res['address']['zipcode']);
            }
          }else{
              this.creditCardForm.controls['address'].setValue(res['address']['address']);
              this.creditCardForm.controls['city'].setValue(res['address']['city']);
              this.creditCardForm.controls['state'].setValue(res['address']['state']);
              this.creditCardForm.controls['zipcode'].setValue(res['address']['zipcode']);
          }
          this.saveButtonDisabled = false;
          this.displayDeliveryAddress = true;
        }
      });
    }
  }
  vaildationCheck(){
    let register = true;
    let card = true;
    let delivery = true;
    let message = '';
    const routeDetails = (this.routeTempletes).length;
    if(this.isDeliverySetting){
      if (this.storeDetails['automatic_route_assignment'])
      {
        if (this.showDeliveryAddress){
          if(routeDetails === 0){
            delivery =  false;
            this.Information.markAllAsTouched();
            message = "delivery";
          }
        }
        else if (this.Information.controls['pickupLocation'].value === 'All')
        {
          delivery =  false;
          message = "delivery";
          if(!!this.featureTags && this.featureTags['sf_select_pickup_event']){
            this.Information.get('pickupLocation')?.setErrors({ invalid: true });    
          }
        }
      }
      else
      {
        if (this.showDeliveryAddress)
        {
          delivery =  false;
          message = "delivery";
        }
        else if (this.Information.controls['pickupLocation'].value === 'All')
        {
          delivery =  false;
          message = "delivery";
        }
      }
    }   
    if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){    
      if(this.showPickupInfo && this.pickupEventControl.invalid){
            delivery = false;
            message = "pickup";
            this.selectTab(0);
      }
    }
    if(this.isFinishDelivery){
    if(!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']){
      if (this.selectedPaymentMethod === 'Credit Card') {
      if(!this.creditCardForm.valid  && this.paymentMethod ==='authorize_net'){
        card = false;
        this.creditCardForm.markAllAsTouched();
        message = "card";
      }
      if(this.featureTags && this.featureTags['sf_stripe_cc_validation']){
        if(!this.stripecreditCardForm.valid  && this.paymentMethod ==='stripe'){
          card = false;
          this.creditCardForm.markAllAsTouched();
          message = "card";
        }
      }
      if (sessionStorage.getItem('cardEnable') === "false")
      {
        card = false;
        this.creditCardForm.markAllAsTouched();
        message = "cardNotEnable";
      }
      }
    }else{
      if(!this.creditCardForm.valid  && this.paymentMethod ==='authorize_net'){
        card = false;
        this.creditCardForm.markAllAsTouched();
        message = "card";
      }
      if(this.featureTags && this.featureTags['sf_stripe_cc_validation']){
        if(!this.stripecreditCardForm.valid  && this.paymentMethod ==='stripe'){
          card = false;
          this.creditCardForm.markAllAsTouched();
          message = "card";
        }
      }
      if (sessionStorage.getItem('cardEnable') === "false")
      {
        card = false;
        this.creditCardForm.markAllAsTouched();
        message = "cardNotEnable";
      }
    }
    }
    if(this.featureTags && this.featureTags['sf_enhance_registration'] && !this.registerForm.value['terms_and_conditions'] && this.storedetails1['enable_website_terms_condition']){
      this.isTermandConditionRequired = true;
      register = false;
      message = "register";
    }
    
    if(!this.registerForm.valid){
      register = false;
      this.registerForm.markAllAsTouched();
      message = "register";
    }
    
    if(register && card && delivery)
      return {message:"Successfully Vaild", valid:true};
    else
      return {message:message, valid:false};
  }

  onRegisterFormSubmit() {
    let validation = this.vaildationCheck();
    if (validation['valid']) {
      let newsletter_subscription = this.registerForm.value
        .newsletter_subscription
        ? "true"
        : "false";
      this.registerForm.value.newsletter_subscription =
        newsletter_subscription;
      this.registerForm.value.email_id =
        this.registerForm.value.email_id.toLowerCase();
      this.isLoadingSignUpBtn = true;
      this.registerForm.value.delivery_preference = this.showPickupInfo ? "Pickup" : "Delivery";
      this.registerForm.value.pickup_location_id = this.pickupLocationId;
      if (!!this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
        this.registerForm.value.preferred_payment_method = this.selectedPaymentMethod;
      }
      if (this.featureTags && this.featureTags['sf_word_of_mouth']) {
        if (this.showReferralInput) {
          const known_by = this.registerForm.value.known_by;
          const internal_notes = this.registerForm.value.internal_notes;
          this.registerForm.value.internal_notes = `${known_by} - ${internal_notes}`
        }
      }
      this.apiService.customerRegister(this.registerForm.value).subscribe(
        (res) => {
          if (res["response"].status === 5) {
            this.notification.warning(
              res["response"].message,
              5000
            );
            this.isLoadingSignUpBtn = false;
          } else if (res["response"].status === 7) {
            this.notification.error(res["response"].message), 5000;
            this.isLoadingSignUpBtn = false;
          } else if (res["response"].status === 1) {
            let resData = res["response"]["data"];
            if (!!resData) {
              localStorage.setItem("token", res["response"]["data"]['token']);
              if (this.isDeliverySetting && this.showDeliveryAddress) {
                if (this.showDeliveryAddress)
                  this.onAddressFormSubmit();
                else
                  this.onSubmitDeliveryDetails();
              }
              if (this.featureTags && this.featureTags['sf_pickup_location']) {
                if (this.isDeliverySetting && !this.showDeliveryAddress) {
                  this.onSubmitDeliveryDetails();
                }
              }
              if (this.featureTags && this.featureTags['ftag_cod_and_other_payment_for_sf']) {
                if (this.selectedPaymentMethod === 'Credit Card') {
                  if (this.isFinishDelivery)
                    this.onCardFormSubmit().then((resp: any) => {
                      setTimeout(() => {
                        this.setLoginDetails(res["response"]["data"]);
                        if (this.featureTags && this.featureTags['sf_register_redirect']) {
                          if (!!this.featureTags && this.featureTags['ftags_membership']) {
                            if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                              if (this.sharedDataService.redirectToMembership) {
                                this.sharedDataService.setRedirectToMembership(false);
                                this.router.navigate(['/membership-purchase']);
                              } else if (this.storedetails1['enable_bulletin_board'] == true) {
                                if (this.storedetails1['bulletin_board_as_landing'] == true) {
                                  this.router.navigate(["/account/bulletinboard"])
                                } else {
                                  this.router.navigate(["/account/orders"]);
                                }
                              } else if (this.storedetails1['enable_bulletin_board'] == false) {
                                this.router.navigate(["/account/orders"]);
                              }
                              else {
                                this.router.navigate(["/account/bulletinboard"]);
                              }
                            } else {
                              if (this.sharedDataService.redirectToMembership) {
                                this.sharedDataService.setRedirectToMembership(false);
                                this.router.navigate(['/membership-purchase']);
                              } else {
                                this.router.navigate(["/account/bulletinboard"]);
                              }
                            }
                          } else {
                            if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                              if (this.storedetails1['enable_bulletin_board'] == true) {
                                if (this.storedetails1['bulletin_board_as_landing'] == true) {
                                  this.router.navigate(["/account/bulletinboard"])
                                } else {
                                  this.router.navigate(["/account/orders"]);
                                }
                              } else if (this.storedetails1['enable_bulletin_board'] == false) {
                                this.router.navigate(["/account/orders"]);
                              }
                              else {
                                this.router.navigate(["/account/bulletinboard"]);
                              }
                            } else {
                              this.router.navigate(["/account/bulletinboard"])
                            }
                          }

                        } else {
                          this.router.navigate(["/shop"])
                        }
                        this.notification.success(
                          res["response"].message,
                          5000
                        );
                      }, 2000);
                    });
                } else {
                  setTimeout(() => {
                    this.setLoginDetails(res["response"]["data"]);
                    if (this.featureTags && this.featureTags['sf_register_redirect']) {
                      if (!!this.featureTags && this.featureTags['ftags_membership']) {
                        if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                          if (this.sharedDataService.redirectToMembership) {
                            this.sharedDataService.setRedirectToMembership(false);
                            this.router.navigate(['/membership-purchase']);
                          } else if (this.storedetails1['enable_bulletin_board'] == true) {
                            if (this.storedetails1['bulletin_board_as_landing'] == true) {
                              this.router.navigate(["/account/bulletinboard"])
                            } else {
                              this.router.navigate(["/account/orders"]);
                            }
                          } else if (this.storedetails1['enable_bulletin_board'] == false) {
                            this.router.navigate(["/account/orders"]);
                          }
                          else {
                            this.router.navigate(["/account/bulletinboard"]);
                          }
                        } else {
                          if (this.sharedDataService.redirectToMembership) {
                            this.sharedDataService.setRedirectToMembership(false);
                            this.router.navigate(['/membership-purchase']);
                          } else {
                            this.router.navigate(["/account/bulletinboard"]);
                          }
                        }
                      } else {
                        if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                          if (this.storedetails1['enable_bulletin_board'] == true) {
                            if (this.storedetails1['bulletin_board_as_landing'] == true) {
                              this.router.navigate(["/account/bulletinboard"])
                            } else {
                              this.router.navigate(["/account/orders"]);
                            }
                          } else if (this.storedetails1['enable_bulletin_board'] == false) {
                            this.router.navigate(["/account/orders"]);
                          }
                          else {
                            this.router.navigate(["/account/bulletinboard"]);
                          }
                        } else {
                          this.router.navigate(["/account/bulletinboard"])
                        }
                      }

                    } else {
                      this.router.navigate(["/shop"])
                    }
                    this.notification.success(
                      res["response"].message,
                      5000
                    );
                  }, 2000);
                }
              } else {
                if (this.isFinishDelivery)
                  this.onCardFormSubmit().then((resp: any) => {
                    setTimeout(() => {
                      this.setLoginDetails(res["response"]["data"]);
                      if (this.featureTags && this.featureTags['sf_register_redirect']) {
                        if (!!this.featureTags && this.featureTags['ftags_membership']) {
                          if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                            if (this.sharedDataService.redirectToMembership) {
                              this.sharedDataService.setRedirectToMembership(false);
                              this.router.navigate(['/membership-purchase']);
                            } else if (this.storedetails1['enable_bulletin_board'] == true) {
                              if (this.storedetails1['bulletin_board_as_landing'] == true) {
                                this.router.navigate(["/account/bulletinboard"])
                              } else {
                                this.router.navigate(["/account/orders"]);
                              }
                            } else if (this.storedetails1['enable_bulletin_board'] == false) {
                              this.router.navigate(["/account/orders"]);
                            }
                            else {
                              this.router.navigate(["/account/bulletinboard"]);
                            }
                          } else {
                            if (this.sharedDataService.redirectToMembership) {
                              this.sharedDataService.setRedirectToMembership(false);
                              this.router.navigate(['/membership-purchase']);
                            } else {
                              this.router.navigate(["/account/bulletinboard"]);
                            }
                          }
                        } else {
                          if (this.featureTags && this.featureTags['ftag_bulletin_board_on_website']) {
                            if (this.storedetails1['enable_bulletin_board'] == true) {
                              if (this.storedetails1['bulletin_board_as_landing'] == true) {
                                this.router.navigate(["/account/bulletinboard"])
                              } else {
                                this.router.navigate(["/account/orders"]);
                              }
                            } else if (this.storedetails1['enable_bulletin_board'] == false) {
                              this.router.navigate(["/account/orders"]);
                            }
                            else {
                              this.router.navigate(["/account/bulletinboard"]);
                            }
                          } else {
                            this.router.navigate(["/account/bulletinboard"])
                          }
                        }

                      } else {
                        this.router.navigate(["/shop"])
                      }
                      this.notification.success(
                        res["response"].message,
                        5000
                      );
                    }, 2000);
                  });
              }

              // this.router.navigate["/home"]
            } else {
              this.registerForm.reset();
              this.notification.success(
                res["response"].message,
                5000
              );
              this.isLoadingSignUpBtn = false;
            }
          } else if (res["response"].status === 0) {
            this.notification.error(res["response"].message, 5000);
            this.isLoadingSignUpBtn = false;
          } else if (
            res["response"].status === 2 ||
            res["response"].status === 3
          ) {
            this.selectTab(1);
            // this.stepper.selectedIndex = 1;
            displayErrorMessage({
              notification: this.notification,
              response: res["response"],
              formControl: this.registerForm.controls,
            });
            this.isLoadingSignUpBtn = false;
          }
        },
        (err) => {
          this.isLoadingSignUpBtn = false;
          console.log(err);
        }
      );
    }
    else {
      if (validation['message'] === 'delivery') {
        this.notification.error("Delivery Address not Vaild!", 5000);
        this.Information.get('address').setErrors({ required: true });
        this.selectTab(0);
      }
      if (validation['message'] === 'card') {
        this.notification.error("You have enter Invaild data please check!", 5000);
        this.selectTab(2);
      }
      if (validation['message'] === 'register') {
        this.notification.error("You have enter Invaild data please check!", 5000);
        this.selectTab(1);
      }
      if (validation['message'] === 'cardNotEnable') {
        this.notification.error("Please enable atleast one payment method", 5000);
        setTimeout(() => {
          this.notification.error("Please contact the site administrator", 5000);
        }, 5000);
        this.selectTab(2);
      }
    }

  }
  onSubmitDeliveryDetails ()
  { 
    if(!!this.featureTags && this.featureTags['sf_select_pickup_event']){
      var params;
      params = {
        delivery_preference : "Pickup",
        pickup_location_id  : this.pickupLocationId,
        event_id           : this.pickupEventControl.value.id
      }
    }else{
      var params;
      params = {
        delivery_preference : "Pickup",
        pickup_location_id  : this.pickupLocationId
      }
    }
    this.apiService.savePickupLocation(params).subscribe(res => { 
      if(res['response'].status === 1) { 
        this.notification.success(res['response'].message, 5000);
        params.address_id = !!res['response']['savedAddress'] ? res['response']['savedAddress']['id'] : null;
        this.addressDetailsStatus = true;
      }
    }, err => {
      console.log(err)
    });
  }
  onAddressFormSubmit(){
    var params;
    let routes = [];
    const InformationData = this.Information.value;
    this.selectedAddress['geometry'] = !!this.selectedAddress['geometry'] ? this.selectedAddress['geometry'] : "";
    let address = this.selectedAddress['formatted_address'].split(",")
    params = {
      address_id        : this.address_id,
      address           : address[0].trim(),
      city              : this.selectedAddress['city'],
      county            : this.selectedAddress['county'],
      geometry          : this.selectedAddress['geometry'],
      state             : this.selectedAddress['state'],
      zipcode           : this.selectedAddress['zipcode'],
      formatted_address : this.selectedAddress['formatted_address'],
      website_check     : "local"
    }
    var apt_suite_no ="";
    if(this.Information.value.apt_suite_no){
      params['apt_suite_no'] = this.Information.value.apt_suite_no;
      apt_suite_no = this.Information.value.apt_suite_no ? "#"+this.Information.value.apt_suite_no+"," : "" ;
    }
    params['address'] = this.Information.value.address;
    params['zipcode'] = this.Information.value.zipcode;
    if(!!this.featureTags && this.featureTags['ftag_user_formatted_address_fix']){
      var formatted_address = `${this.Information.value.address}, ${apt_suite_no} ${this.selectedAddress['city']}`;
    } else {
      var formatted_address = `${this.Information.value.address}, ${apt_suite_no} ${this.selectedAddress['city']}, ${this.selectedAddress['state']}, ${this.Information.value.zipcode}`;
    }
      formatted_address += this.selectedAddress['county'] ? ","+this.selectedAddress['county']: "" ;
      if(!!this.featureTags && this.featureTags['ftag_user_formatted_address_fix']){
        formatted_address += this.selectedAddress['state'] ? ","+this.selectedAddress['state']: "" ;
        formatted_address += this.Information.value.zipcode ? ","+this.Information.value.zipcode: "" ;
      }
        params['formatted_address'] = formatted_address;
    if(!!this.featureTags && !this.featureTags['ftag_sf_delivery_address_notattached_email']){ 
      if (this.storeDetails['automatic_route_assignment'])
      {
        routes['route_templates'] = this.routeTempletes;
        this.apiService.saveContactRoutes(this.routeTempletes).subscribe(res => {
          this.notification.success(res['response'].message, 5000);
        });
      }
    }
    this.apiService.updateCustomerDetails(params).subscribe(res => {
      this.saveButtonOptions.active = false;
      if(res['response'].status === 1) {
        this.notification.success(res['response'].message, 5000);
        params.address_id = !!res['response']['savedAddress'] ? res['response']['savedAddress']['id'] : null;
        this.addressDetailsStatus = true;
        if(!!this.featureTags && this.featureTags['ftag_sf_delivery_address_notattached_email']){ 
          if (this.storeDetails['automatic_route_assignment'])
          {
            routes['route_templates'] = this.routeTempletes;
            this.apiService.saveContactRoutes(this.routeTempletes).subscribe(res => {
              this.notification.success(res['response'].message, 5000);
            });
          }
        }
      }else if(res['response'].status === 0) {
        this.notification.error(res['response'].message, 5000);
        this.addressDetailsStatus = false;
      }else if(res['response'].status === 2 || res['response'].status === 3) {
        displayErrorMessage({
          notification: this.notification, 
          response: res['response']
        });
        this.addressDetailsStatus = false;
      }else if(res['response'].status === 6) {
        this.notification.error(res['response'].message, 5000);
        this.addressDetailsStatus = false;
      }
    }, err => {
      this.addressDetailsStatus = false;
      this.saveButtonOptions.active = false;
      console.log(err)
    });
  }

  onCardFormSubmit(): Promise<number> {
    return new Promise((resolve, reject) => {
      if(this.featureTags && this.featureTags['sf_add_credit_card']){ 
        if(this.featureTags && this.featureTags['sf_stripe_payment']){ 
          if(this.paymentMethod ==='stripe'){
          if(this.stripecreditCardForm.valid && this.stripeFormValid ){
              this.createToken().subscribe(
                (payment_method_id: string) => {
                  // Collect form values and token_id for the API request
                  const formData = this.stripecreditCardForm.value;
                  const requestData = {
                    payment_method_id,                   
                    address: formData.address,   
                    city: formData.city,         
                    state: formData.state,      
                    zipcode: formData.zipcode,
                  };
                  this.apiService.addNewCreditCard(requestData).subscribe(
                    (data:any) => {  
                      if (data?.response.status === 0) {
                        this.notification.error(data.response.message, 5000);
                        this.cardInformationStatus = false;
                        resolve(data?.response);
                      } 
                      else if (data?.response.status === 1) {
                        this.notification.success('Credit card successfully added', 5000);
                        this.cardInformationStatus = true;
                        resolve(data?.response);
                      } 
                      else if (data?.response.status === 2 || data?.response.status === 3) {
                        displayErrorMessage({
                          notification: this.notification,
                          response: data.response,
                          formControl: this.creditCardForm.controls
                        });
                        this.cardInformationStatus = false;
                        resolve(data?.response);
                      } 
                      else if (data?.response.status === 4 || data?.response.status === 6) {
                        this.notification.error(data.response.message, 5000);
                        this.cardInformationStatus = false;
                        resolve(data?.response);
                      } 
                      else {
                        this.notification.error(data.response.message, 5000);
                        this.cardInformationStatus = false;
                        resolve(data?.response);
                      }
                    },
                    err => {
                      console.log(err);
                      this.cardInformationStatus = false;
                      reject(err); // Reject the promise on error
                    }
                  );
                })
            } else {
            reject(new Error('Credit card form is invalid'));
          }
        }else if(this.paymentMethod ==='authorize_net'){
          if (this.creditCardForm.valid) {
            const params = this.getCreditCardDetails();
            if (params) {
              this.apiService.addNewCreditCard(params).subscribe(
                (data:any) => {  
                  if (data?.response.status === 0) {
                    // this.notification.error(data.response.message, 5000);
                    this.cardInformationStatus = false;
                    resolve(data?.response);
                  } 
                  else if (data?.response.status === 1) {
                    this.notification.success('Credit card successfully added', 5000);
                    this.cardInformationStatus = true;
                    resolve(data?.response);
                  } 
                  else if (data?.response.status === 2 || data?.response.status === 3) {
                    displayErrorMessage({
                      notification: this.notification,
                      response: data.response,
                      formControl: this.creditCardForm.controls
                    });
                    this.cardInformationStatus = false;
                    resolve(data?.response);
                  } 
                  else if (data?.response.status === 4 || data?.response.status === 6) {
                    // this.notification.error(data.response.message, 5000);
                    this.cardInformationStatus = false;
                    resolve(data?.response);
                  } 
                  else {
                    // this.notification.error(data.response.message, 5000);
                    this.cardInformationStatus = false;
                    resolve(data?.response);
                  }
                },
                err => {
                  console.log(err);
                  this.cardInformationStatus = false;
                  reject(err); // Reject the promise on error
                }
              );
            } else {
              reject(new Error('Invalid credit card details'));
            }
          } else {
            reject(new Error('Credit card form is invalid'));
          }
        }

        }else{
         if (this.creditCardForm.valid) {
          const params = this.getCreditCardDetails();
          if (params) {
            this.apiService.addNewCreditCard(params).subscribe(
              (data:any) => {  
                if (data?.response.status === 0) {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 1) {
                  this.notification.success('Credit card successfully added', 5000);
                  this.cardInformationStatus = true;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 2 || data?.response.status === 3) {
                  displayErrorMessage({
                    notification: this.notification,
                    response: data.response,
                    formControl: this.creditCardForm.controls
                  });
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 4 || data?.response.status === 6) {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                }
              },
              err => {
                console.log(err);
                this.cardInformationStatus = false;
                reject(err); // Reject the promise on error
              }
            );
          } else {
            reject(new Error('Invalid credit card details'));
          }
        } else {
          reject(new Error('Credit card form is invalid'));
        }
       }
      }else{
        if (this.creditCardForm.valid) {
          const params = this.getCreditCardDetails();
          if (params) {
            this.apiService.addNewCreditCard(params).subscribe(
              (data:any) => {  
                if (data?.response.status === 0) {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 1) {
                  this.notification.success('Credit card successfully added', 5000);
                  this.cardInformationStatus = true;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 2 || data?.response.status === 3) {
                  displayErrorMessage({
                    notification: this.notification,
                    response: data.response,
                    formControl: this.creditCardForm.controls
                  });
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else if (data?.response.status === 4 || data?.response.status === 6) {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                } 
                else {
                  // this.notification.error(data.response.message, 5000);
                  this.cardInformationStatus = false;
                  resolve(data?.response);
                }
              },
              err => {
                console.log(err);
                this.cardInformationStatus = false;
                reject(err); // Reject the promise on error
              }
            );
          } else {
            reject(new Error('Invalid credit card details'));
          }
        } else {
          reject(new Error('Credit card form is invalid'));
        }
      }
      
    });
  }



  setLoginDetails(response: any) {
    this.subscripeNavigation = this.router.events.subscribe(
        (event: Event) => {
            if (event instanceof NavigationEnd) {
                this.isLoadingSignInBtn = false;
                this.isLoadingSignUpBtn = false;
            }
        }
    );
    // sessionStorage.setItem("token", response.token);
    this.apiService.setLogin({
        loggedIn: true,
        userDetails: response.user_details,
    });
    let cartData = JSON.parse(sessionStorage.getItem("cart"));
    sessionStorage.setItem("order_exist", response["order_exist"]);

    this.notification.success("You logged in successfully!", 5000);
  }

  getCreditCardDetails() {
    let cardNumber = removeWhiteSpaces(CreditCard.formatCardNumber(this.creditCardForm.get('number').value));
    let cardExpiry = removeWhiteSpaces(this.creditCardForm.get('expiry').value);
    let cardCVC = removeWhiteSpaces(this.creditCardForm.get('cvc').value);
    let cardType = CreditCard.cardType(cardNumber);
    if(cardExpiry.indexOf('/') !== 2) {
      cardExpiry = cardExpiry.slice(0, 2)+'/'+cardExpiry.slice(-2);
    }
    cardCVC = cardCVC.length > 4 ? cardCVC.slice(0,4) : cardCVC;
    return {
      ...this.creditCardForm.value,
      number: cardNumber,
      cardtype: cardType, 
      expiry: cardExpiry,
      cvc: cardCVC
    };
    
  }
  clickedMarker(label: string, index: number) {
    console.log(`clicked the marker: ${label || index}`)
  }
  
  markerDragEnd(m: marker, $event: MouseEvent) {
    console.log('dragEnd', m, $event);
  }
  onChange(event: any): void {
    const { elementType, error, empty, complete } = event;
  
    // Map element types to error message variables
    const errorMessages = {
      cardNumber: 'carderrorMessage',
      cardExpiry: 'expiryerrorMessage',
      cardCvc: 'cvcerrorMessage'
    };
  
    // Update error messages or clear them based on the event's error property
    if (errorMessages[elementType] !== undefined) {
      this[errorMessages[elementType]] = error ? error.message : '';
    }
  
    // Update form validity only when all errors are cleared
    this.stripeFormValid =
      !this.carderrorMessage &&
      !this.expiryerrorMessage &&
      !this.cvcerrorMessage &&
      complete && // Ensure the card field is complete
      !empty;     // Ensure the card field is not empty
  }

  createToken(): Observable<string> {
    return new Observable((observer) => {
      let test =false
      // if(test){
        this.stripeService.createPaymentMethod(
          {
            type: 'card',
            card: this.card.element,
            billing_details: {
              address: {
                city:this.stripecreditCardForm.value.city,
                country:'US',
                line1:this.stripecreditCardForm.value.address,
                line2:'',
                postal_code:this.stripecreditCardForm.value.zipcode,
                state:this.stripecreditCardForm.value.state
              }
            },
          }
        ).subscribe((result:any) => {        
          if (result.paymentMethod) {
            // Emit the token ID to be used in the next step
            observer.next(result.paymentMethod.id);
            observer.complete();
          } else if (result.error) {
            // Emit an error message if token creation fails
            observer.error(result.error.message);
          }
        });
      // }
     
    });
  }

  onPaymentMethodChange(method: string) {    
    this.selectedPaymentMethod = method;
  }

  GetCMSPages() {
    this.apiService.setLoader(true);
    let storeId = JSON.parse(sessionStorage.getItem('store')).id;
    this.apiService.getContentItems({type: 'pages', store_id:storeId, item_handle:'terms-and-conditions'}).subscribe(result => {
      if (result['response']['status'] === 1) {
        this.apiService.SetCmsPage(result['response']['data']);
        if (result['response']['data'].length > 0) {
          const Htmlcontent = result['response']['data'][0]['content'];
          this.safeHtmlContent = Htmlcontent;
        }
      }
     });
  }
  
  
}
// just an interface for type safety.
interface marker {
  lat: number;
	lng: number;
	label?: string;
	formatAddress: string;
	deliveryDays: string;
  notes:string;
}

